module.exports = window["wc"]["blocksCheckoutEvents"];